import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import CheckboxComponent from '../../CheckboxComponent/CheckboxComponent';
import { getCompanyId } from '../../../../storage/localStorage';
// import { functions } from 'firebase';

class SelectComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            option: {},
        };
    }

    componentDidMount() {
        const { multiWithCheckbox, options, id } = this.props.formProps;
        let { onCompanySelect, getMembers, getLicenses, versionMapping } = this.props.formProps;
        const { input } = this.props;

        if (multiWithCheckbox) {
            options.forEach((option) => {
                //retain the values for the Sign up and Edit company form

                if (input.value !== '') {
                    let inputValueArray = typeof input.value === 'string' ? input.value.split(',') : input.value;
                    //convert the label to comma space separated values
                    const inputPlatformLabel = typeof input.value === 'string' ? input.value.split(',').join(', ') : input.value.join(', ');
                    const inputPlatformValue = typeof input.value === 'string' ? input.value : input.value.join(',');

                    this.setState({
                        option: {
                            label: inputPlatformLabel,
                            value: inputPlatformValue,
                        },
                    }, function () {
                        input.onChange(inputPlatformValue);
                    });

                    //check the values which were initally selected
                    inputValueArray.forEach((option) => {
                        this.setState({
                            [option]: true,
                        }, () => this.checkboxValueWrapper);
                    });
                } else {
                    this.setState({
                        [option.value]: false,
                    });
                }
            });
        }

        //set default company value only if the user is on Licenses page (company dropdown)
        if (id === 'listofCompanies') {
            let setDefaultValue = options[0];
            let companyId = getCompanyId();

            if (companyId) {
                setDefaultValue = options.filter((company) => {
                    return company.value === companyId;
                })[0];
            }

            if (options.length < 1) {
                setDefaultValue = { value: '' };
                this.setState({
                    noneSelected: true,
                });
            }

            this.setState({
                option: setDefaultValue,
                [setDefaultValue.value]: setDefaultValue.value,
            }, function () {
                input.onChange(setDefaultValue.value);

                //call the getLicenses and getMembers depending on the initial value of a Company
                onCompanySelect(setDefaultValue.value).then(function () {
                    if (setDefaultValue.value.length > 0) {
                        getMembers(setDefaultValue.value);
                        getLicenses(setDefaultValue.value);
                    }
                });
            });
        } else if (id === 'sdkVersion') {
            let defaultVersion = options[0];

            versionMapping.forEach((versionObj) => {
                if (versionObj.isSelected) {
                    for (var index in options) {
                        if (options[index].label === versionObj.versionName) {
                            defaultVersion = options[index];
                        }
                    }
                }
            })

            this.setState({
                option: defaultVersion,
                [defaultVersion.value]: defaultVersion.value,
            }, function () {
                input.onChange(defaultVersion.value);
            })
        }
    }

    componentDidUpdate() {
        const { options, id } = this.props.formProps;
        let { onCompanySelect, getMembers, getLicenses } = this.props.formProps;
        const { input } = this.props;
        const { noneSelected } = this.state;

        //set default company value only if the user is on Licenses page (company dropdown)
        if (id === 'listofCompanies' && noneSelected && options && options.length > 0) {
            this.handleInitialSelect(options, input, onCompanySelect, getMembers, getLicenses);
        }
    }

    handleInitialSelect = (options, input, onCompanySelect, getMembers, getLicenses) => {
        let setDefaultValue = options[0];
        let companyId = getCompanyId();

        if (companyId) {
            setDefaultValue = options.filter((company) => {
                return company.value === companyId;
            })[0];
        }

        this.setState({
            option: setDefaultValue,
            [setDefaultValue.value]: setDefaultValue.value,
            noneSelected: false,
        }, function () {
            input.onChange(setDefaultValue.value);

            //call the getLicenses and getMembers depending on the initial value of a Company
            onCompanySelect(setDefaultValue.value).then(function () {
                if (setDefaultValue.value.length > 0) {
                    getMembers(setDefaultValue.value);
                    getLicenses(setDefaultValue.value);
                }
            });
        });
    }

    checkboxValueWrapper = (option) => {
        const title = option.label;

        return <CheckboxComponent
            name={title + 'Checkbox'}
            onChange={new Function}
            checked={this.state[title]}
            placeholder={title}
        />;
    }

    render() {
        const { input, label, className } = this.props;
        let { formProps } = this.props;
        let { onCompanySelect, getMembers, isLoading, getLicenses, api, versionMapping, onVersionSelect } = this.props.formProps;

        formProps.options = formProps.options.map((value) => typeof value === 'string' ? { label: value, value } : value);

        if (formProps.multiWithCheckbox) {
            formProps = Object.assign(formProps, {
                optionClassName: 'checkbox-option',
                optionRenderer: this.checkboxValueWrapper,
                closeOnSelect: false,
                value: this.state.option,
                onChange: (value) => {
                    let { option } = this.state;
                    const values = option.label ? option.label.split(', ') : [];

                    if (this.state[value]) {
                        values.splice(values.indexOf(value), 1);
                    } else {
                        values.push(value);
                    }

                    const inputLabel = values.join(', ');
                    const inputValue = values.join(',');

                    this.setState({
                        option: {
                            label: inputLabel,
                            value: inputValue,
                        },
                        [value]: !this.state[value],
                    });
                    input.onChange(inputValue);
                },
            });
        } else if (formProps.id === 'sdkVersion') {
            formProps = Object.assign(formProps, {
                onChange: (versionName) => {
                    formProps.options.forEach((version) => {
                        if (version['value'] === versionName) {
                            this.setState({
                                option: {
                                    label: version['label'],
                                    value: version['value'],
                                },
                                [version['value']]: version['value'],
                            }, () => {
                                if (!isLoading) {
                                    versionMapping.forEach((versionObj) => {
                                        if (versionObj.versionName === versionName) {
                                            onVersionSelect(api, versionObj['version'].replace(/\./g, '-'))
                                        }
                                    })
                                }
                                input.onChange(versionName);
                            });
                        }
                    });
                },
            });
        } else if (formProps.id === 'listofCompanies') {
            formProps = Object.assign(formProps, {
                onChange: (firebaseId) => {
                    formProps.options.forEach((result) => {
                        if (result['value'] === firebaseId) {
                            this.setState({
                                option: {
                                    label: result['label'],
                                    value: result['value'],
                                },
                                [result['value']]: result['value'],
                            }, () => {
                                if (!isLoading) {
                                    onCompanySelect(firebaseId).then(function () {
                                        getMembers(firebaseId);
                                        getLicenses(firebaseId);
                                    });
                                }
                                input.onChange(firebaseId);
                            });
                        }
                    });
                },
            });
        }

        return <Select
            {...input}
            {...formProps}
            className={className}
            label={label}
            clearable={false}
            simpleValue
            labelKey="label"
            valueKey="value"
            onBlur={() => input.onBlur(input.value)}
            arrowRenderer={({ isOpen }) => <span className={'glyphicon ' + (isOpen ? 'open' : 'closed')} />}
        />;
    }
}

SelectComponent.defaultProps = {
    input: {},
    formProps: {},
    className: '',
};

SelectComponent.propTypes = {
    label: PropTypes.string,
    input: PropTypes.object.isRequired,
    formProps: PropTypes.object.isRequired,
    className: PropTypes.string.isRequired,
    versionMapping: PropTypes.array,
};

export default SelectComponent;



// WEBPACK FOOTER //
// ./src/components/core/FieldGroupComponent/FieldComponents/SelectComponent.js